// extracted by mini-css-extract-plugin
export default {"MessageComposer":"MessageComposer_MessageComposer__zFXRU","textContainer":"MessageComposer_textContainer__r7rFU","Send":"MessageComposer_Send__LWnQn"};